import { IPayloadCreateRole } from 'app/api/role/model'
import R from 'app/assets/R'
import { IRefModal } from 'app/components/common/ModalComponent'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { notificationController } from 'app/controllers/notification-controller'
import { useCreateRole } from 'app/react-query/hook/role'
import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IFormCreateRole } from './type'

export const useHook = () => {
  const { t } = useTranslation()
  const [form] = BaseForm.useForm<IFormCreateRole>()
  const modalRef = useRef<IRefModal>({})
  
  const { mutateAsync: mutateAsyncUpdate, isLoading } = useCreateRole()

  const [isDefault, setIsDefault] = useState(false)

  const handleSubmit = async (values: IFormCreateRole) => {
    const newAccount: IPayloadCreateRole = {
      name: values?.name,
      description: values?.description,
      permissionIds: values?.permissionIds,
      isDefault
    }

    await mutateAsyncUpdate?.(newAccount)
    modalRef?.current?.hide?.()
    form?.resetFields()
    notificationController.success({
      message: t(R.strings.success),
    })
  }

  return {
    form,
    modalRef,
    handleSubmit,
    isLoading,
    setIsDefault,
    isDefault,
  }
}
